// import products from '@/data/products.json'
// import products from '@/data/products_android.json'
import useApi from '@/composition/api.js'

const products = []
const api = useApi()
const platform = api.getPlatform()

const state = {
	ids: {
		simple_original_subscription_3_months: {
			ios: 'simple_original_subscription_3_months',
			android: 'simple_original_3_month_sale'
		},
		simple_high_price_subscription_3_months: {
			ios: 'simple_high_price_subscription_3_months',
			android: 'android_simple_full_price_subscription_3_months' //TODO
		},
		simple_original_premium_subscription_12_months: {
			ios: 'simple_original_premium_subscription_12_months',
			android: 'simple_premium_year'
		},
		simple_full_price_subscription_3_months: {
			ios: 'simple_full_price_subscription_3_months',
			android: 'android_simple_full_price_subscription_3_months'
		},
		simple_price_down_subscription_3_months: {
			ios: 'simple_price_down_subscription_3_months',
			android: 'simple_original_3_month'
		},
		simple_original_subscription_1_month: {
			ios: 'simple_original_subscription_1_month',
			android: 'simple_original_1_month'
		},
		simple_sale_subscription_12_months_63off_no_trial: {
			ios: 'simple_sale_subscription_12_months_63off_no_trial',
			android: 'simple_sale_year'
		},
		simple_original_subscription_12_months: {
			ios: 'simple_original_subscription_12_months',
			android: 'simple_original_year'
		},
		simple_original_subscription_12_months_trial: {
			ios: 'simple_original_subscription_12_months_trial',
			android: 'android_simple_original_subscription_12_months_trial'
		},
		simple_special_subscription_3_months: {
			ios: 'simple_special_subscription_3_months',
			android: 'android_simple_special_subscription_3_months'
		},
		simple_price_down_subscription_12_months: {
			ios: 'simple_price_down_subscription_12_months',
			android: 'simple_price_down_year'
		},
		simple_high_price_subscription_12_months: {
			ios: 'simple_high_price_subscription_12_months',
			android: 'simple_original_year'
		},
		simple_high_full_price_subscription_12_months: {
			ios: 'simple_high_full_price_subscription_12_months',
			android: 'android_simple_full_price_subscription_3_months'
		},
		simple_high_full_price_subscription_12_months_ss: {
			ios: 'simple_high_full_price_subscription_12_months',
			android: 'simple_discount_year_for_introductory'
		},
		simple_sale_subscription_3_months_for_introductory: {
			ios: 'simple_sale_subscription_3_months_for_introductory',
			android: 'android_simple_full_price_subscription_3_months'
		},
		simple_bf_subscription_3_month_discount: {
			ios: 'simple_sale_subscription_3_months',
			android: 'android_simple_special_subscription_3_months'
		},
		simple_bf_subscription_3_month_wo_discount: {
			ios: 'simple_original_subscription_3_months',
			android: 'simple_original_1_month'
		},
		simple_bf_subscription_annual: {
			ios: 'simple_original_premium_subscription_12_months',
			android: 'simple_price_down_year'
		},
		simple_xmas_offer_subscription_3_month_discount: {
			ios: 'simple_sale_subscription_3_months_for_introductory',
			android: ''
		},
		simple_xmas_offer_subscription_3_month_wo_discount: {
			ios: 'simple_original_subscription_3_months',
			android: ''
		},
		simple_xmas_offer_subscription_annual: {
			ios: 'simple_original_premium_subscription_12_months',
			android: ''
		},
		simple_3_months_4999_9_for_introductory: {
			ios: 'simple_3_months_4999_9_for_introductory',
			android: 'android_simple_full_price_subscription_3_months' /** TODO */
		},
		simple_full_price_subscription_12_months: {
			ios: 'simple_full_price_subscription_12_months',
			android: 'simple_low_price_1_month'
		},
		simple_nutrition_workbook: {
			ios: 'simple_nutrition_workbook',
			android: 'android_simple_nutrition_workbook_low_price'
		},
		simple_workout_workbook: {
			ios: 'simple_workout_workbook',
			android: 'android_simple_workout_workbook_low_price'
		},
		ios_workout_workbook_sale: {
			ios: 'ios_workout_workbook_sale',
			android: ''
		},
		simple_all_workbooks: {
			ios: 'simple_all_workbooks',
			android: 'android_simple_down_all_workbooks'
		},
		simple_down_all_workbooks: {
			ios: 'simple_down_all_workbooks',
			android: 'android_simple_down_all_workbooks'
		},
		simple_original_subscription_12_weeks_2999_trial_7d: {
			ios: 'ios_simple_original_subscription_12_weeks_2999_trial_7d',
			android: 'android_simple_original_subscription_12_weeks_2999_trial_7d'
		},
		simple_original_subscription_12_months_trial_7d: {
			ios: 'simple_original_subscription_12_months_trial_7d',
			android: 'simple_original_year_7_trial'
		},
		simple_special_subscription_12_months: {
			ios: 'simple_special_subscription_12_months',
			android: '' // TODO
		},
		simple_original_subscription_6_months: {
			ios: 'simple_original_subscription_6_months',
			android: 'android_simple_original_subscription_6_months'
		},
		simple_original_lifetime: {
			ios: 'simple_original_lifetime',
			android: '' // TODO
		},
		simple_premium_12_weeks: {
			ios: '', // TODO
			android: 'simple_premium_12_weeks'
		},
		simple_recipes_3_months_7d_trial_low: {
			ios: '',
			android: 'simple_recipes_3_months_7d_trial_low'
		},
		ios_emotional_eating_course: {
			ios: 'ios_emotional_eating_course',
			android: ''
		}
	},
	prices: []
}

const getters = {
	find: (state) => (id) => {
		return state.prices.find((price) => price.id == id)
	},

	getData: (state, getters) => (data) => {
		return data.map(({ ...product }) => {
			const price_data = getters.getProductById(product.id)

			if (price_data) {
				product.id = price_data.id
				product.localized_price = price_data.localizedPriceString
				product.currency_code = price_data.currencyCode
				product.product_price = price_data.price
				product.duration_months = price_data.durationMonths

				if (product.old) {
					const old_product = getters.getProductById(product.old.id)

					product.old = {
						price: old_product.localizedPriceString,
						weekly_price: old_product.localizedPricePerWeekString,
						monthly_price: old_product.localizedPricePerMonthString,
						price_per_year: old_product.localizedPricePerYearString,
						discount: Math.floor(((old_product.price - price_data.price) / old_product.price) * 100),
						discount_per_year: Math.floor(
							(((12 / old_product.durationMonths) * old_product.price -
								(12 / price_data.durationMonths) * price_data.price) /
								((12 / old_product.durationMonths) * old_product.price)) *
								100
						)
					}
				}

				if (price_data.introductoryPrice) {
					product.introductory = {
						discount: Math.floor(((price_data.price - price_data.introductoryPrice) / price_data.price) * 100),
						localized_price: price_data.localizedIntroductoryPrice
					}
				}

				const fields = ['terms', 'text', 'subtitle', 'price', 'text_over_badge', 'period', 'sidebar_title']
				fields.forEach((field) => {
					if (product[field]) {
						product[field] = product[field].replace('[price]', price_data.localizedPriceString)
						product[field] = product[field].replace('[introductory_price]', price_data.localizedIntroductoryPrice)
						product[field] = product[field].replace('[weekly_price]', price_data.localizedPricePerWeekString)
						product[field] = product[field].replace('[monthly_price]', price_data.localizedPricePerMonthString)
						if (typeof product.old?.price !== 'undefined') {
							product[field] = product[field].replace('[old_price]', `<s>${product.old.price}</s>`)
							product[field] = product[field].replace('[old_price_per_year]', `<s>${product.old.price_per_year}</s>`)
							product[field] = product[field].replace('[discount_per_year]', `${product.old.discount_per_year}%`)
						}
					}
				})
			}

			return {
				...product,
				hasTrial: price_data?.hasTrial,
				duration_months: price_data?.durationMonths,
				currency: price_data?.currencyCode,
				symbol: price_data?.currencySymbol,
				trial_days: price_data?.trialDurationDays || 0
			}
		})
	},

	getProductById: (state) => (id) => {
		const platform_product_id = state.ids[id][platform]
		return state.prices.find((price) => price.id == platform_product_id)
	}
}

const actions = {}

const mutations = {
	store(state, prices) {
		state.prices = (typeof prices == 'string' ? JSON.parse(prices) : prices) || products
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
